export const FIRST_TIME_SETUP_GET_PASSWORD_REQUEST =
  'FIRST_TIME_SETUP_GET_PASSWORD_REQUEST';
export const FIRST_TIME_SETUP_GET_PASSWORD_SUCCESS =
  'FIRST_TIME_SETUP_GET_PASSWORD_SUCCESS';
export const FIRST_TIME_SETUP_GET_PASSWORD_FAILURE =
  'FIRST_TIME_SETUP_GET_PASSWORD_FAILURE';

export const FIRST_TIME_SETUP_DEFINE_PASSWORD_REQUEST =
  'FIRST_TIME_SETUP_DEFINE_PASSWORD_REQUEST';
export const FIRST_TIME_SETUP_DEFINE_PASSWORD_SUCCESS =
  'FIRST_TIME_SETUP_DEFINE_PASSWORD_SUCCESS';
export const FIRST_TIME_SETUP_DEFINE_PASSWORD_FAILURE =
  'FIRST_TIME_SETUP_DEFINE_PASSWORD_FAILURE';

export const FIRST_TIME_SETUP_CREATE_SERVICE_ACCOUNT_REQUEST =
  'FIRST_TIME_SETUP_CREATE_SERVICE_ACCOUNT_REQUEST';
export const FIRST_TIME_SETUP_CREATE_SERVICE_ACCOUNT_SUCCESS =
  'FIRST_TIME_SETUP_CREATE_SERVICE_ACCOUNT_SUCCESS';
export const FIRST_TIME_SETUP_CREATE_SERVICE_ACCOUNT_FAILURE =
  'FIRST_TIME_SETUP_CREATE_SERVICE_ACCOUNT_FAILURE';

export const FIRST_TIME_SETUP_SKIP_SERVICE_ACCOUNT_REQUEST =
  'FIRST_TIME_SETUP_SKIP_SERVICE_ACCOUNT_REQUEST';
export const FIRST_TIME_SETUP_SKIP_SERVICE_ACCOUNT_SUCCESS =
  'FIRST_TIME_SETUP_SKIP_SERVICE_ACCOUNT_SUCCESS';
export const FIRST_TIME_SETUP_SKIP_SERVICE_ACCOUNT_FAILURE =
  'FIRST_TIME_SETUP_SKIP_SERVICE_ACCOUNT_FAILURE';
